import GrowthPlannerCta from './GrowthPlannerCta';

export default GrowthPlannerCta;

export type { IGrowthPlannerCtaProps } from './GrowthPlannerCta';
